/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetAllDocuments = async (params = {}) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/document-list?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDocumentManagementFiltersDropdown = async () => {
  return Request.call({
    url: `/micro/document-list/filters`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDocumentManagementTypes = async (filters) => {
  return Request.call({
    url: `/micro/document-list/types`,
    method: 'GET',
    params: filters,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDocumentManagementSources = async () => {
  return Request.call({
    url: `/micro/document-list/sources`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetDocumentManagementStorage = async () => {
  return Request.call({
    url: `/micro/document-list/storage-quota`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiDownloadDocument = async (data) => {
  return Request.call({
    url: `/micro/document-list/download`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    responseType: 'blob',
  });
};
export const apiDownloadSharedDocuments = async (data) => {
  return Request.call({
    url: `/micro/document-list/download-documents`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
    responseType: 'blob',
  });
};
export const apiRenameDocument = async (id, data) => {
  return Request.call({
    url: `/micro/document-list/${id}/rename`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiEditTypeDocument = async (data) => {
  return Request.call({
    url: `/micro/document-list/edit-type`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiSetDatesDocument = async (data) => {
  return Request.call({
    url: `/micro/document-list/date-reminder`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiSaveToDocument = async (data) => {
  return Request.call({
    url: `/micro/document-list/save-to`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiActionDocument = async (key, data) => {
  return Request.call({
    url: `/micro/document-list/${key}`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSharedDocumentToken = async (data) => {
  return Request.call({
    url: `/micro/document-list/shared`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSharedDocumentInfo = async (token) => {
  return Request.call({
    url: `/micro/document-list/shared/${token}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateDocumentType = async (data) => {
  return Request.call({
    url: `/micro/document-list/types`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
